<template>
  <div>
    <li class="sidebar-item pointer" @click.stop="isModalResetResultsVisible = true">
      <a class="sidebar-link waves-effect waves-dark sidebar-link-custom">
        <span class="whitespace-normal horizontal layout start">
          <aha-icon
            class="sidebar-link-icon"
            name="reset"
            width="24"
            height="24"
            viewBox="0 0 16 20"
          />
          <span class="hide-menu nav-left-text pb-0.5">{{ $t('Reset this slide') }}</span>
        </span>
      </a>
    </li>
    <ModalResetSlideResults
      v-if="isModalResetResultsVisible"
      :selectedSlides="[slideActive]"
      @hide="closeModalResetResults()"
      @makeSlideActive="makeSlideActive"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'

import ModalResetSlideResults from '@/components-v2/modals/ClearDataSlide.vue'

export default {
  components: {
    ModalResetSlideResults,
  },
  data: () => ({
    isModalResetResultsVisible: false,
  }),
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isSmallScreen() {
      return window.innerWidth < 768
    },
  },
  methods: {
    ...mapActions(['setSlideActiveAction', 'setSelectedSlideIdsAction']),
    closeModalResetResults() {
      this.isModalResetResultsVisible = false
      Utils.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        'Modal clear data slide > Close modal',
      )
    },
    resetContentSlideToolbar() {
      EventBus.$emit('show-freestyle-editor-toolbar', false)
      this.$store.state.selectingBlocks = []
    },
    deselectAllSlides() {
      // Trigger mouseup in 0, 0 to deselect all for now
      document.dispatchEvent(new MouseEvent('mouseup', { x: 0, y: 0 }))
      this.setSelectedSlideIdsAction([])
    },
    activeSlideDetail(isDelete) {
      if (this.isSmallScreen && isDelete) {
        this.$store.state.activeModelDetailSlide = false
      } else {
        this.$store.state.activeModelDetailSlide = true
      }
    },
    makeSlideActive(item, isDelete, clickSource) {
      if (!item) return
      this.activeSlideDetail(isDelete)
      this.resetContentSlideToolbar()

      // Prevent multi-select on mobile
      if (this.isSmallScreen) {
        this.deselectAllSlides()
      }
      if (item.type === 'pickAnswer') {
        item.hideResult = false
        item.showCorrectOption = false
      }
      if (item.id) {
        setTimeout(() => {
          this.$store.dispatch('updateSlideActive', {
            id: null,
          })
        }, 20)
        setTimeout(() => {
          this.setSlideActiveAction(item)
          EventBus.$emit('eventHandleSetValueTransition')
        }, 100)
      } else {
        this.setSlideActiveAction(item)
        EventBus.$emit('eventHandleSetValueTransition')
      }

      EventBus.$emit('SideLeft: setSelectedSlideIds', [item.id])
      EventBus.$emit('updateNextSlide', item.id, clickSource)
      this.$store.state.continueQuiz = false

      Utils.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        'Select Slide > Make Active',
        `Presentation: ${this.$store.state.presentation.id}`,
        null,
        {
          slideId: item.id,
          convertedFromDocument: item.type === 'freestyle' && item.image !== null,
        },
      )
    },
  },
}
</script>

<style  lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.sidebar-item {
  width: unset;
  .sidebar-link {
    padding: 9px 15px 9px 12px !important;
    &.sidebar-link-custom {
      white-space: normal;
    }
  }
  .nav-left-text {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: 16px;
  }
  .sidebar-link-icon {
    margin-right: 12px;
  }
}
</style>
